import { get, post } from '@/utils/apiBase.js';

// 获取数据
const getProQuickActions = option => {
  return get('/apis/project/cp_admin/get_pro_quick_actions', option)
}
// 获取负责cp的运营和商务信息
const getCpOperator = option => {
  return get('/apis/product/get_cp_operator', option)
}
// 用户修改地址及备注权限
const addressLock = option => {
  return post('/apis/project_new/address_lock', option)
}
// 获取项目关联店铺信息
const getRelationInfo = option => {
  return get('/apis/relation_shop/get_relation_info', option)
}
// 取消项目关联店铺
const delRelation = option => {
  return get('/apis/relation_shop/del_relation', option)
}
// 搜索店铺信息
const getShopInfo = option => {
  return get('/apis/relation_shop/get_shop_info', option)
}
// 关联店铺
const addRelation = option => {
  return get('/apis/relation_shop/add_relation', option)
}
// 更换惯量账号时-获取临时token
const createUserToken = option => {
  return get('/apis/project/create_user_token', option)
}
// 检测是否扫码关联
const lockerrModianUser = option => {
  return post('/apis/project/lockerr_modian_user', option)
}
// 获取品牌列表
const getBrandList = option => {
  return get('/apis/project/brand_list', option)
}
// 绑定/更新品牌
const bindingBrand = option => {
  return post('/apis/project/binding_brand', option)
}
// 获取创意详情
const getIdeaInfoByProId = option => {
  return get('/apis/project/cp/get_idea_info_by_pro_id', option)
}
// 关闭创意链接快捷跳转众筹
const setIdeaQuickJump = option => {
  return post('/apis/project/cp/set_idea_quick_jump', option)
}
// 检测是否可取消众筹
const checkProjectCancel = option => {
  return post('/apis/project_zc/check_project_cancel', option)
}
// 删除项目
const DelProject = option => {
  return post('/apis/project/del_project', option)
}
// 申请取消众筹
const CancelProject = option => {
  return post('/apis/ajax/cancel_project', option)
}
// 判断是否显示“关联lockerr粉丝群”按钮
const OpenLockerrStatus = option => {
  return get('/apis/project/open_lockerr_status', option)
}
// 修改售卖时间
const EditProSellingTime = option => {
  return post('/apis/project/cp_admin/edit_pro_selling_time', option)
}
// 众筹转创意生成创意ID
const ProConvertIdea = option => {
  return post('/apis/project/cp_admin/pro_convert_idea', option)
}
// 众筹转个人愿望
const ProConvertWish = option => {
  return post('/apis/project/cp_admin/pro_convert_wish', option)
}

export default {
    getProQuickActions,
    getCpOperator,
    addressLock,
    getRelationInfo,
    delRelation,
    getShopInfo,
    addRelation,
    createUserToken,
    lockerrModianUser,
    getBrandList,
    bindingBrand,
    getIdeaInfoByProId,
    setIdeaQuickJump,
    checkProjectCancel,
    DelProject,
    CancelProject,
    OpenLockerrStatus,
    EditProSellingTime,
    ProConvertIdea,
    ProConvertWish
};